import type { CartLineItem } from '@/modules/cart/domain/CartLineItem';

export const isProductSponsored = (product: CartLineItem): boolean => {
  return !!product?.custom?.fields?.resolvedBidId;
};
